import { FIELD_DOCS } from './fieldDocs';
import { HEAT_DOCS } from './heatDocs';
import { MANAGEMENT_DOCS } from './managementDocs';
import type { DocSchema } from './schema';
import type { DocType } from './types';

/**
 * 양식 문서의 칸 정의 모음(V574 · DOC-136). 묶음 파일마다 따로 고친다 —
 * managementDocs(안전보건경영 · 위험성평가) · fieldDocs(점검 · 안전작업 · 소통 · 비상) · heatDocs(온열질환).
 */
export const DOC_SCHEMAS: Record<DocType, DocSchema> = { ...MANAGEMENT_DOCS, ...FIELD_DOCS, ...HEAT_DOCS };
